"use strict";var r=require("styled-components");require("./styles-cjs-DuHD-usW.js");var a=require("./breakpoint-cjs-69WayOPp.js"),o=require("./color-cjs-BusDQ-L_.js");const e=r.css`
  .ant-btn {
    border-radius: 12px;
  }
  .ant-btn-primary:not(.ant-btn-disabled, [disabled], .ant-btn-background-ghost) {
    background-color: var(--color-primary);
    border-color: var(--color-primary);
  }
  .ant-btn-background-ghost:not(:disabled):hover {
    color: var(--color-primary);
    border-color: var(--color-primary);
  }
  .ant-btn-primary.ant-btn-background-ghost {
    color: var(--color-primary);
    background-color: transparent;
    border-color: var(--color-primary);
    box-shadow: none;
  }
  .ant-btn-default:not(:disabled):hover,
  .ant-btn-dashed:not(:disabled):hover {
    color: var(--color-primary-hover);
    border-color: var(--color-primary-hover);
  }
  .ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover,
  .ant-btn-primary:hover:not(.ant-btn-disabled, [disabled]),
  .ant-btn-primary:focus:not(.ant-btn-disabled, [disabled]),
  .ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: var(--color-primary-hover);
    color: var(--color-white);
  }
`,t=r.css`
  .ant-input-number-input,
  .ant-picker {
    height: var(--spacing-height-xlarge);
    border-radius: var(--spacing-borderRadius-small);
    border: 1px solid var(--color-disabled);
    width: 100%;
  }
  .ant-input-affix-wrapper {
    height: var(--spacing-height-xlarge);
    border-radius: var(--spacing-borderRadius-small);
    border: 1px solid var(--color-disabled);
    &:hover {
      border-color: var(--color-primary-hover) !important;
      border-right-width: 1px !important;
    }
    &:focus {
      border-color: var(--color-primary-hover) !important;
      border-right-width: 1px !important;
    }
  }
  .ant-input-textarea-affix-wrapper {
    height: auto;
  }
  .ant-picker-input {
    flex-direction: row-reverse;
    font-size: var(--typography-size-s3);
    .ant-picker-suffix {
      margin-left: 0;
      margin-right: 4px;
    }
  }
  .ant-form-item-control-input-content:focus,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused,
  .ant-picker:hover,
  .ant-picker-focused {
    border-color: var(--color-primary-hover);
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: 0 0 0 2px var(--color-primary-opacity-ten);
  }
  .ant-select-selector {
    height: var(--spacing-height-xlarge);
    border-radius: var(--spacing-borderRadius-small);
    font-size: var(--typography-size-s3);
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    border-color: var(--color-primary);
  }
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: var(--color-primary-opacity-ten);
  }
  .ant-input {
    border-radius: var(--spacing-borderRadius-small);
    font-size: var(--typography-size-s3) !important;
    &::placeholder {
      color: var(--color-black2) !important;
      opacity: 1;
    }
    &:hover {
      border-color: var(--color-primary-hover);
      border-right-width: 1px !important;
    }
    &:focus {
      border-color: var(--color-primary-hover);
      border-right-width: 1px !important;
    }
  }
  .google-maps-autocomplete-input {
    height: var(--spacing-height-xlarge);
  }
  .ant-select-selection-search {
    display: flex;
    align-items: center;
  }
  .ant-select {
    height: var(--spacing-height-xlarge);
    border-radius: var(--spacing-borderRadius-small);

    .ant-select-arrow {
      svg {
        color: var(--color-black1);
      }
    }

    &:hover .ant-select-selector {
      border-color: var(--color-primary-hover) !important;
      border-right-width: 1px !important;
    }

    &:focus .ant-select-selector {
      border-color: var(--color-primary-hover) !important;
      border-right-width: 1px !important;
    }

    &.ant-select-single .ant-select-selector {
      box-shadow: 0 0 0 2px var(--color-primary-opacity-ten) !important;
    }

    .ant-select-selector {
      height: var(--spacing-height-xlarge) !important;
      border-radius: var(--spacing-borderRadius-small) !important;
    }
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      display: inline-flex;
      align-items: center;
    }
  }
  .ant-checkbox-wrapper {
    align-items: flex-start;
    grid-template-columns: calc(16px * 1.6) 1fr !important;
    &:hover {
      .ant-checkbox-inner {
        border-color: var(--color-primary);
      }
      .ant-checkbox-checked {
        .ant-checkbox-inner {
          background-color: var(--color-primary) !important;
        }
      }
    }
    .ant-checkbox {
      border-color: var(--color-primary);
      &:hover::after {
        visibility: hidden !important;
      }
    }
    .ant-checkbox-checked {
      .ant-checkbox-inner {
        background-color: var(--color-primary);
        border-color: var(--color-primary);
        &:hover {
          background-color: var(--color-primary);
          border-color: var(--color-primary);
        }
      }
    }
    .ant-checkbox-inner {
      width: calc(16px * 1.6);
      height: calc(16px * 1.6);
      border-radius: var(--spacing-borderRadius-xSmall) !important;
      &::after {
        width: calc(9.7px * 1.1);
        height: calc(15.1px * 1.1);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        top: 1px;
        left: 6px;
      }
    }
  }
`,i=r.css``,n=`\n  --background-app: ${a.b.app};\n  --background-appInverse: ${a.b.appInverse};\n  --background-positive: ${a.b.positive};\n  --background-negative: ${a.b.negative};\n  --background-warning: ${a.b.warning};\n\n  --color-primary: ${o.c.primary};\n  --color-primary-hover: ${o.c.primary}CC;\n  --color-primary-opacity-ten: ${o.c.primary}1A;\n  --color-primary2: ${o.c.primary2};\n  --color-white: ${o.c.white};\n  --color-offWhite: ${o.c.offWhite};\n  --color-offWhite2: ${o.c.offWhite2};\n  --color-disabled: ${o.c.disabled};\n  --color-black: ${o.c.black};\n  --color-black1: ${o.c.black1};\n  --color-black2: ${o.c.black2};\n  --color-black3: ${o.c.black3};\n  --character-primary: ${o.c.black4};\n  --color-gray1: ${o.c.gray1};\n  --color-gray2: ${o.c.gray2};\n  --color-success: ${o.c.success};\n  --color-success2: ${o.c.success2};\n  --color-success-dark: ${o.c.successDark};\n  --color-error: ${o.c.error};\n  --color-error2: ${o.c.error2};\n  --color-error-light: ${o.c.errorLight};\n  --color-warning: ${o.c.warning};\n  --color-warning2: ${o.c.warning2};\n  --color-warning-light: ${o.c.warningLight};\n  --color-help: ${o.c.help};\n  --color-help-light: ${o.c.helpLigth};\n  --color-total-pay-shipping: ${o.c.primary};\n  --color-total-pay-freeTag: ${o.c.primary};\n  --color-total-pay-subtotal: ${o.c.black1};\n  --color-total-pay-taxes: ${o.c.black1};\n  --color-total-pay-discounts: ${o.c.error};\n  --color-total-pay-coupon: ${o.c.error};\n  --color-purple: ${o.c.purple};\n\n  --shadow-background: ${a.s.background};\n  --shadow-boxShadow: ${a.s.boxShadow};\n  --shadow-cardSlotShadow: ${a.s.cardSlotShadow};\n  --shadow-cardSlotHoverShadow: ${a.s.cardSlotHoverShadow};\n  --shadow-adminCardShadow: ${a.s.adminCardShadow};\n\n  --spacing-padding-small: ${a.c.padding.small}px;\n  --spacing-padding-medium: ${a.c.padding.medium}px;\n  --spacing-padding-large: ${a.c.padding.large}px;\n  --spacing-padding-xlarge: ${a.c.padding.xlarge}px;\n  --spacing-padding-xxlarge: ${a.c.padding.xxlarge}px;\n\n  --spacing-margin-xxSmall: ${a.c.margin.xxSmall}px;\n  --spacing-margin-xSmall: ${a.c.margin.xSmall}px;\n  --spacing-margin-small: ${a.c.margin.small}px;\n  --spacing-margin-medium: ${a.c.margin.medium}px;\n  --spacing-margin-large: ${a.c.margin.large}px;\n  --spacing-margin-xlarge: ${a.c.margin.xlarge}px;\n\n  --spacing-borderRadius-default: ${a.c.borderRadius.default}px;\n  --spacing-borderRadius-big: ${a.c.borderRadius.big}px;\n  --spacing-borderRadius-xSmall: ${a.c.borderRadius.xSmall}px;\n  --spacing-borderRadius-small: ${a.c.borderRadius.small}px;\n  --spacing-borderRadius-medium: ${a.c.borderRadius.medium}px;\n  --spacing-borderRadius-large: ${a.c.borderRadius.large}px;\n  --spacing-borderRadius-xLarge: ${a.c.borderRadius.xLarge}px;\n  --spacing-borderRadius-xxLarge: ${a.c.borderRadius.xxLarge}px;\n\n  --spacing-height-small: ${a.c.heights.small}px;\n  --spacing-height-medium: ${a.c.heights.medium}px;\n  --spacing-height-large: ${a.c.heights.large}px;\n  --spacing-height-xlarge: ${a.c.heights.xLarge}px;\n\n  --typography-type-primary: ${a.t.type.primary};\n  --typography-type-code: ${a.t.type.code};\n  --typography-weight-semiLight: ${a.t.weight.semiLight};\n  --typography-weight-normal: ${a.t.weight.normal};\n  --typography-weight-semiRegular: ${a.t.weight.semiRegular};\n  --typography-weight-semiBold: ${a.t.weight.semiBold};\n  --typography-weight-bold: ${a.t.weight.bold};\n  --typography-weight-extrabold: ${a.t.weight.extrabold};\n  --typography-weight-black: ${a.t.weight.black};\n  --typography-weight-primary: ${a.t.weight.bold};\n\n  --typography-size-s1: ${a.t.size.s1}px;\n  --typography-size-s2: ${a.t.size.s2}px;\n  --typography-size-s3: ${a.t.size.s3}px;\n  --typography-size-s4: ${a.t.size.s4}px;\n  --typography-size-m1: ${a.t.size.m1}px;\n  --typography-size-m2: ${a.t.size.m2}px;\n  --typography-size-m3: ${a.t.size.m3}px;\n  --typography-size-l1: ${a.t.size.l1}px;\n  --typography-size-l2: ${a.t.size.l2}px;\n  --typography-size-l3: ${a.t.size.l3}px;\n  --typography-size-code: ${a.t.size.code}px;\n\n  --border-radius-items-small: 8px;\n  --border-radius-items-medium: 12px;\n  --border-radius-items-large: 16px;\n\n  --border-color: ${o.c.disabled};\n  --border-weight: 1px;\n  --dash-size: 3px;\n  --gap-size: 2px;\n\n  --breakpoint-xSmall: ${a.a.xSmall}px;\n  --breakpoint-small: ${a.a.small}px;\n  --breakpoint-medium: ${a.a.medium}px;\n  --breakpoint-large: ${a.a.large}px;`;var c=r.css`
  ${n}
`;const l=r.css`
  .yuno-modal__close-btn {
    display: none;
  }
  .yuno-status {
    background-color: transparent;
  }
  .yuno-status__containment-width {
    background: var(--background-app, white);
  }
  .yuno-status_payment-fail,
  .yuno-status_payment-reject {
    .yuno-status__containment-width {
      @media screen and (min-width: 768px) {
        background: transparent;
      }
    }
    .yuno-status__button {
      position: relative;
      visibility: hidden;
    }
    .yuno-status__button:after {
      visibility: visible;
      position: relative;
      align-self: center;
      content: 'Continuar';
      left: -56px;
      color: rgb(81, 60, 225);
    }
    .yuno-status__button:hover {
      text-decoration: underline;
      color: inherit;
    }
  }
`,p=r.css`
  ${c}
  font-family: var(--typography-type-primary);
  font-size: var(--typography-size-s3);
  color: ${o.c.darkest};
  font-display: swap;

  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  -webkit-overflow-scrolling: touch;

  * {
    box-sizing: border-box;
    font-family: var(--typography-type-primary);
    font-display: swap;
  }

  button,
  input,
  textarea,
  select {
    outline: none;
    font-family: var(--typography-type-primary);
  }

  sub,
  sup {
    font-size: 0.8em;
  }

  sub {
    bottom: -0.2em;
  }

  sup {
    top: -0.2em;
  }

  b,
  em {
    font-weight: var(--typography-weight-primary);
  }

  hr {
    border: none;
    border-top: 1px solid ${o.c.border};
    clear: both;
    margin-bottom: 1.25rem;
  }

  code,
  pre {
    font-family: var(--typography-type-code);
    font-size: ${a.t.size.s2-1}px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    display: inline-block;
    padding-left: 2px;
    padding-right: 2px;
    vertical-align: baseline;
    color: ${o.c.secondary};
  }

  pre {
    line-height: 18px;
    padding: 11px 1rem;
    white-space: pre-wrap;
    background: rgba(0, 0, 0, 0.05);
    color: ${o.c.darkest};
    border-radius: 3px;
    margin: 1rem 0;
  }
  h1,
  h2,
  h3,
  h4,
  p {
    margin: 0;
  }
  ${e}
  ${i}
  ${t}
  ${l}
  .resource-capacity-calendar {
    .ant-picker-panel {
      width: 100%;
      background-color: ${o.c.backgroundColor};
      box-shadow: none;
      -webkit-box-shadow: none;
    }
    .ant-picker-cell-selected .ant-calendar-date.selectedDate,
    .selectedDate {
      background-color: ${o.c.selectedDateBackground};
      color: ${o.c.selectedDateColor};
    }
    .ant-picker-cell-today .multi-date {
      border: 1px solid ${o.c.cellColor};
      color: ${o.c.cellColor};
    }
    .ant-picker-cell-in-view .multi-date:hover {
      background-color: ${o.c.cellColor};
      color: ${o.c.selectedDateColor};
    }
    .ant-calendar-selected-day .ant-calendar-date {
      background: transparent;
    }
    .ant-calendar-disabled-cell .ant-calendar-date.multi-date {
      background: ${o.c.disabledCell};
    }
    .clean-btn {
      color: ${o.c.clearBtn};
    }
  }
  .pac-container {
    margin: 0 -2%;
    background: white;
    box-shadow: 0px 4px 16px rgba(56, 56, 56, 0.12) !important;
    border-radius: 8px;
    padding: 20px 12px;
    margin-top: 10px;
    margin-left: -24px;
    .pac-item {
      border: none;
      padding: 8px 10px;
      color: #373737;
      font-size: 14px;
      line-height: 20px;
      border-radius: 8px;
      &:hover {
        cursor: pointer;
        font-weight: var(--typography-weight-primary);
        background-color: #e8f4ff;
      }
      .pac-icon {
        margin-top: 0;
      }
    }
  }
`,s="https://fonts.googleapis.com/css?family=Nunito&display=swap",d=r.createGlobalStyle`
  body {
    ${p}
  }
`;var g={bodyStyles:p,fontUrl:s,GlobalStyle:d,variables:c};exports.G=d,exports.b=p,exports.f=s,exports.g=g,exports.r=n,exports.v=c;